import './App.css';

function App() {
  return (
    <div className="App">
      <img src="/circle.png" alt="monkey" />
    </div>
  );
}

export default App;
